'use strict';

// Old scripts, migrate these to es6 modules
import '../scripts/js/scripts';

import ready from './utils';
import Marketo from './components/marketo';
import DefaultMarketoForm from './components/default-marketo-form';
import 'jquery-match-height';
import HeaderBanner from './components/header-banner';
import OneTrust from './components/onetrust';
import HomeHero from './components/home-hero';

ready(() => {
    new Marketo();
    new DefaultMarketoForm();
    HeaderBanner.init();
    OneTrust.init();
    HomeHero.init();
});